import { memo, useEffect } from 'react';

import { cartAtom, useSetValue } from '@/store';

export type AhavaProps = {
  getCart: () => void;
};

export const Ahava = memo<AhavaProps>((props) => {
  const { getCart } = props;

  const setCart = useSetValue(cartAtom);

  useEffect(() => {
    const targetNode = document.querySelector('#shopify-section-cart-drawer > section');

    if (!targetNode) {
      console.error('Target node not found');
      return;
    }

    const checkCartOpen = () => {
      const isEmptyCartDrawer = targetNode.querySelector('[data-cart-drawer]')?.children.length === 0;

      setCart((s) => ({
        ...s,
        isOpen: isEmptyCartDrawer ? false : targetNode.children.length > 0,
      }));
    };

    checkCartOpen();
    const config = { childList: true, subtree: true };

    const callback = () => checkCartOpen();

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);

    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    document.addEventListener('cart:added', getCart);
    document.addEventListener('cart:updated', getCart);

    return () => {
      document.removeEventListener('cart:added', getCart);
      document.removeEventListener('cart:updated', getCart);
    };
  }, [getCart]);

  return null;
});

Ahava.displayName = 'Ahava';
